import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { userLogout } from "../../../store/auth/auth.slice.js";
import {
  getUserFullName,
  getUserInitials,
  getAccountType,
  getUserLoginId,
} from "../../../store/auth/selectors.js";
import inmobius_logo from "../../../assets/images/inmobius_logo.png";
import logo_separator from "../../../assets/images/logo_separator.svg";
import infinity_learn from "../../../assets/images/infinity_learn.svg";
import dropdown_icon from "../../../assets/images/dropdown_icon.svg";
import "./NavBar.css";

function NavBar() {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const popupRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userFullName = useSelector(getUserFullName);
  const userInitials = useSelector(getUserInitials);
  const userAccountType = useSelector(getAccountType);
  const userLoginId = useSelector(getUserLoginId);

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIsPopupVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    dispatch(userLogout());
    navigate("/login");
  };

  return (
    <div className="navBar">
      <img
        src={inmobius_logo}
        alt="logo"
        style={{ width: "40px", height: "40px" }}
      />
      <img className="logo-separator" src={logo_separator} />
      <img
        src={infinity_learn}
        alt="logo"
        style={{ width: "50px", height: "35px" }}
      />
      <div className="user-info-container">
        <span className="user-full-name">{userFullName}</span>
        <span className="user-account-type">{userAccountType}</span>
      </div>
      <div className="user-initials-circle">{userInitials}</div>
      <img
        src={dropdown_icon}
        alt="dropdown"
        onClick={togglePopup}
        className="dropdown-icon"
      />
      {isPopupVisible && (
        <div className="popup-logout" ref={popupRef}>
          <div className="popup-login-id">Login Id: {userLoginId}</div>
          <div className="popup-logout-button" onClick={handleLogout}>
            Logout
          </div>
        </div>
      )}
    </div>
  );
}

export default NavBar;
